export default "__VITE_ASSET__BaTd9671__"